import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AauthService } from 'src/app/services/aauth.service';
import { DBkeys } from 'src/app/services/db-keys';
import { LocalStoreManager } from 'src/app/services/local-store-manager.service';
import { RegisterService } from '../register.service';
import { timer, iif } from 'rxjs';

declare function InitMyJs(): void; // fake to skip ide error.

@Component({
  selector: 'app-register3',
  templateUrl: './register3.component.html',
  styleUrls: ['./register3.component.scss']
})
export class Register3Component implements OnInit {

  isProcessStart = false;
  isFlyout = this.registerService._isFlyout;
  isClaim = false;

  model = {
    actiByEmail: false,
    email: '',
    phone: '',
    actiCode: '',
  };

  constructor(
      private router: Router,
      public aauthService: AauthService,
      private localStorage: LocalStoreManager,
      public registerService: RegisterService) { }

  ngOnInit(): void {
    try {
      InitMyJs();
    } catch (error) {
      console.error(error);
    }

    this.model.email = this.localStorage.getData(DBkeys.LOCAL_KEY_REG + 'email');
    this.model.phone = this.localStorage.getData(DBkeys.LOCAL_KEY_REG + 'phone');
    this.isClaim = this.localStorage.getData(DBkeys.LOCAL_KEY_ISCLAIM);

    if ((this.model.phone == '') || (this.model.phone == null)) {
      this.model.actiByEmail = true;
    }
  }

  finishProcess() {
    setTimeout(() => { this.isProcessStart = false; }, 1000);
  }

  startProcess() {
    if (this.isProcessStart) {
      return false;
    }

    this.isProcessStart = true;
    return true;
  }

  sendSmsCode() {
    if (!this.startProcess()) { return; }
    this.aauthService.sendActiveCodeByPhone(this.model.email, this.model.phone);
    this.finishProcess();
  }
  sendEmailCode() {
    if (!this.startProcess()) { return; }
    this.aauthService.sendActiveCodeByEmail(this.model.email);
    this.finishProcess();
  }

  onSendActiveCode() {
    if (this.model.actiByEmail) {
      this.sendEmailCode();
    } else {
      this.sendSmsCode();
    }
  }

  onSubmit() {
    if (!this.startProcess()) { return; }
    this.aauthService.validActiveCode(this.model.actiCode, this.model.actiByEmail, this.model.email, this.model.phone, false, this.isFlyout);
    this.finishProcess();
  }
  onSubmitMember() {
    if (!this.startProcess()) { return; }
    this.aauthService.validActiveCode(this.model.actiCode, this.model.actiByEmail, this.model.email, this.model.phone, true, this.isFlyout);
    this.finishProcess();
  }
}
